import Component from "../../classes/Component";
import Swiper, {Navigation} from "swiper";
import {$dom} from "../../helpers/dom";
import variables from "../../variables";

const {breakpoints} = variables;

const rootElId = 'js-landing-description-carousel';

export default function () {

    return new Component({
        name: 'descriptionCarousel',
        requiredTargets: '#'+rootElId,
        onInit() {
            const [rootEl] = this.targets;

            this.carousel = new Swiper($dom.get('.swiper', rootEl), {
                modules: [Navigation],
                slidesPerView: 3,
                spaceBetween: 16,
                navigation: {
                    nextEl: $dom.get('[data-carousel-control="next"]', rootEl),
                    prevEl: $dom.get('[data-carousel-control="prev"]', rootEl)
                },
                breakpoints: {
                    [0]: {
                        slidesPerView: 1
                    },
                    [breakpoints.sm]: {
                        slidesPerView: 2
                    },
                    [breakpoints.md]: {
                        slidesPerView: 3
                    },
                    [breakpoints.lg]: {
                        slidesPerView: 4
                    }
                }
            });
        },
        onDestroy() {
            if(this.carousel instanceof Swiper) this.carousel.destroy();
            delete this.carousel;
        }
    })
}
